import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, model, output } from "@angular/core";
import { StrategyStateEnum } from "@front/m19-api-client";
import { IToggleComponent, ITooltipDirective } from "@front/m19-ui";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";

@Component({
  selector: "app-state-badge",
  imports: [CommonModule, IToggleComponent, ITooltipDirective, TranslocoDirective],
  templateUrl: "./state-badge.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StateBadgeComponent implements ICellRendererAngularComp {
  readonly translocoService = inject(TranslocoService);
  readonly StrategyState = StrategyStateEnum;

  state = model<StrategyStateEnum | undefined>();
  disabled = model<boolean>(false);
  loading = model<boolean>(false);

  stateBadgeClick = output<StrategyStateEnum>();
  onStateChange: (() => void) | undefined;

  isChecked = computed(() => this.state() === StrategyStateEnum.ENABLED);

  label = computed(() => {
    if (this.state() === StrategyStateEnum.ENABLED) return this.translocoService.translate("common.activated");
    else return this.translocoService.translate("strategy-page.paused");
  });

  agInit(
    params: ICellRendererParams & {
      state: StrategyStateEnum;
      disabled: boolean;
      loading: boolean;
      onStateChange: () => void;
    },
  ): void {
    this.state.set(params.state);
    this.disabled.set(params.disabled);
    this.loading.set(params.loading);
    this.onStateChange = params.onStateChange;
  }

  refresh(_: ICellRendererParams): boolean {
    return false;
  }

  handleClick() {
    if (this.loading() || this.disabled()) return;
    this.onStateChange?.();
    this.stateBadgeClick.emit(
      this.state() === StrategyStateEnum.ENABLED ? StrategyStateEnum.PAUSED : StrategyStateEnum.ENABLED,
    );
  }
}
